var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-spa-layout-page',[_c('template',{slot:"title"},[_vm._v(_vm._s(_vm.$t('profitability.index.title')))]),_vm._v(" "),_c('router-view',{key:'profitability-' + _vm.$route.fullPath,attrs:{"slot":"content"},slot:"content"})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }